import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Residential from "./pages/Residential";
import Commercial from "./pages/Commercial";
import Fabrication from "./pages/Fabrication";
import DuctSealing from "./pages/DuctSealing";
import ServiceArea from "./pages/ServiceArea";
import Gallery from "./pages/Gallery";
import Team from "./pages/Team";
import Contact from "./pages/Contact";
import Careers from "./pages/Careers";
import { Toaster } from "./components/ui/toaster";
import { ContentProvider } from "./context/ContentContext";
import Admin from "./pages/Admin";

function App() {
  return (
    <ContentProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/admin/*" element={<Admin />} />
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="residential" element={<Residential />} />
          <Route path="commercial" element={<Commercial />} />
          <Route path="fabrication" element={<Fabrication />} />
          <Route path="duct-sealing" element={<DuctSealing />} />
          <Route path="service-areas/:slug" element={<ServiceArea />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="team" element={<Team />} />
          <Route path="contact" element={<Contact />} />
          <Route path="careers" element={<Careers />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster />
    </BrowserRouter>
    </ContentProvider>
  );
}

export default App;
